module.exports = __webpack_public_path__ + "static/introducing-flex-devices-desktop-v2-cf9fdeaf35acaae930918f0355cb20db.png";